<template>
  <!-- <transition name="fade"> -->
    <div class="right-sidebar" :class="{ 'dir-rtl' : language.rtl }">
      <div class="right-sidebar__content">
        <div class="right-sidebar__logo-wrapper">
          <img v-if="logo" class="right-sidebar__logo" :src="`${$store.state.assetsPath}${logo}`">
        </div>
        <div class="right-sidebar__minimap-wrapper">
          <transition name="fade">
            <img v-if="minimap" :src="`${minimap}`" :key="minimap" class="right-sidebar__minimap">
          </transition>
        </div>

        <div class="right-sidebar__heading-wrapper">
          <transition name="sidebar-fade" mode="out-in">
            <div v-if="heading" class="right-sidebar__heading" :key="activePage._id" v-html="heading"></div>
          </transition>
        </div>

        <div class="right-sidebar__description-wrapper">
          <transition name="sidebar-fade" mode="out-in">
            <div v-if="description" class="right-sidebar__description" :key="activePage._id" v-html="description"></div>
          </transition>
        </div>
        <div class="right-sidebar__qr-wrapper">
          <transition name="sidebar-fade" mode="out-in">
            <div  v-if="qrUrl" class="right-sidebar__qr" :key="activePage._id">
              <div class="right-sidebar__qr-heading">More Things To See</div>
              <div class="right-sidebar__qr-row">
                <qrcode-vue
                  class="qrcode"
                  :value="activePage.qrUrl"
                  size="1000"
                  renderAs="canvas"
                />
                <div class="right-sidebar__qr-message">
                  Scan this QR Code to receive more comprehensive information direct to your phone.
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  <!-- </transition> -->
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  props: {
    logo: String,
    minimap: String,
    heading: String,
    description: String,
    qrUrl: String,
  },

  components: { QrcodeVue },

  computed: {
    ...mapGetters([
      'activePage'
    ]),
    language () {
      return this.$store.getters.language
    }
  },

  methods: {
    isNavItemActive (item) {
      if (this.$route.fullPath === item.to) {
        return true
      }
    },
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.right-sidebar {
  height: 98rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 32.5rem;
  z-index: 100;

  &::before {
    background: linear-gradient(90deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.738) 19%,
      rgba(0, 0, 0, 0.541) 34%,
      rgba(0, 0, 0, 0.382) 47%,
      rgba(0, 0, 0, 0.278) 56.5%,
      rgba(0, 0, 0, 0.194) 65%,
      rgba(0, 0, 0, 0.126) 73%,
      rgba(0, 0, 0, 0.075) 80.2%,
      rgba(0, 0, 0, 0.042) 86.1%,
      rgba(0, 0, 0, 0.021) 91%,
      rgba(0, 0, 0, 0.008) 95.2%,
      rgba(0, 0, 0, 0.002) 98.2%,
      rgba(0, 0, 0, 0) 100%
    );
    bottom: 0;
    content: '';
    left: 0;
    opacity: .5;
    position: absolute;
    top: 0;
    width: $overlay-gradient-width;
    z-index: 10;
  }

  &__content {
    background: $sidebar-bg-color;
    display: grid;
    padding: 7.5rem 0 0 0;
    position: relative;
    grid-gap: 0;
    grid-template-columns: 1fr;
    grid-template-rows: 25rem 10rem 6rem 35rem 16.25rem;
    height: 100%;
  }

  &__logo-wrapper {
    box-sizing: border-box;
    padding: 0 4rem;
    text-align: left;
  }

  &__logo {
    max-width: 100%;
  }

  &__minimap-wrapper {
    // margin-bottom: 4em;
    position: relative;
    padding-right: 5rem;
  }

  &__minimap {
    // width: 100%;
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    left: 0;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  &__heading-wrapper {
    position: relative;
  }

  &__heading {
    align-items: flex-end;
    color: $basecolor;
    display: flex;
    font-size: 1.8rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.2;
    padding-bottom: 1rem;
    padding-left: 4rem;
    padding-right: 4rem;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-transform: uppercase;
  }

  &__description-wrapper {
    position: relative;
  }

  &__description {
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    line-height: 1.5rem;
    max-height: 70rem;
    padding-left: 4rem;
    padding-right: 4rem;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-weight: 400;
    overflow: hidden;
  }

  &__qr-wrapper {
    position: relative;
  }

  &__qr {
    padding-left: 4rem;
    padding-right: 4rem;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    &-heading {
      color: $basecolor;
      font-size: 1.2rem;
      margin-bottom: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &-row {
      display: flex;
    }

    &-message {
      font-size: 1.1rem;
      letter-spacing: 0.05em;
      line-height: 1.5rem;
      font-weight: 400;
      padding-left: 1.75rem;
      padding-right: 4rem;
    }
  }
}

.qrcode {
  flex-shrink: 0;
  background: $white;
  display: block;
  display: grid;
  place-items: center;
  height: 8rem !important;
  width: 8rem !important;
  border-radius: 1rem;


  canvas {
    height: 7rem !important;
    width: 7rem !important;
  }
}
</style>
